function injectScript(iframe) {
    const iDocument = iframe.contentWindow.document;
    const input = iDocument.querySelector('input');

    // Replace search icon
    const origSearchIcon = document.querySelector('button.gh-search img');
    const newSearchIcon = document.createElement('img');
    newSearchIcon.src = origSearchIcon.src;
    newSearchIcon.className = origSearchIcon.className;
    input.previousSibling.remove();
    input.parentElement.insertBefore(newSearchIcon, input);
}

function injectStyle(iframe, cssPath) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = cssPath;
    iframe.contentWindow.document.head.appendChild(link);
}

export default function injectSearch() {
    window.onload = () => {
        const searchButton = document.querySelector('.gh-search');
        searchButton.addEventListener('click', function () {
            const iframe = document
                .getElementById('sodo-search-root')
                .querySelector('iframe');
            iframe.onload = () => {
                injectStyle(iframe, searchButton.dataset.extraStyle);
                injectScript(iframe);
            };
        });
    };
}
